<template>
    <small class="form-text text-muted" v-text="description"></small>
</template>

<script>
  export default {
    props: {
      description: '',
    },
  };
</script>